// app/javascript/controllers/auto_refresh_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,       // URL, die zyklisch geladen wird
    interval: Number   // Intervall in ms
  }

  connect() {
    this.timeLeft = this.intervalValue / 1000 // Sekunden bis nächster Refresh
    this.startCountdown()
    this.refresh()                             // Sofort erstes Laden

    this.timer = setInterval(() => {
      this.refresh()
      this.timeLeft = this.intervalValue / 1000
    }, this.intervalValue)

    console.log("auto-refresh connected")
  }

  disconnect() {
    clearInterval(this.timer)
    clearInterval(this.countdownTimer)
  }

  async refresh() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      })
      if (response.ok) {
        const html = await response.text()
        this.element.querySelector("[data-refresh-target='content']").innerHTML = html
        localStorage.setItem(this.urlValue, html) // letzter Stand speichern
        this.showError(false)
      }
    } catch (error) {
      // Offline: letzte Version aus LocalStorage
      const last = localStorage.getItem(this.urlValue)
      if (last) this.element.querySelector("[data-refresh-target='content']").innerHTML = last
      
      this.showError(true)
    }
  }
 
  showError(flag) {
    const errorEl = this.element.querySelector("[data-refresh-target='error']")
    if (!errorEl) return

    if (flag) {
      errorEl.classList.remove("d-none")
      errorEl.classList.add("d-block")
    } else {
      errorEl.classList.remove("d-block")
      errorEl.classList.add("d-none")
    }
  }

  startCountdown() {
    this.countdownTimer = setInterval(() => {
      this.timeLeft -= 1
      const countdownEl = this.element.querySelector("[data-refresh-target='countdown']")
      if (countdownEl) {
        countdownEl.textContent = `${this.formatTime(this.timeLeft)}`
      }
    }, 1000)
  }

  formatTime(seconds) {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0')
    const s = (seconds % 60).toString().padStart(2, '0')
    return `${m}:${s}`
  }
}

